// extracted by mini-css-extract-plugin
export var achievementIcon = "AchievementIcon-module__achievementIcon___cRYZS";